import GameAbstract from '../core/GameAbstract';
import { autobind } from 'frontools/decorators/Autobind';
import { Assets } from '../core/Assets';
import { GameMode } from '../core/GameManager';
import GameTimer from '../core/components/GameTimer';
import { Hammer } from './Hammer';

declare var TweenMax: any; 

export class Cosmocostaud extends GameAbstract {
    public static instance                  : Cosmocostaud;

    public static CLICK                     : string                        = 'click';
    public static RIGHTCLICK                : string                        = 'rightclick';
    public static TOUCHSTART                : string                        = 'touchstart';
    public static TOUCHEND                  : string                        = 'touchend';

    private _bgContainer                    : PIXI.Container                = new PIXI.Container;     
    private _bgTop                          : PIXI.Sprite;     
    private _bgBottom                       : PIXI.Sprite;     
    
    private _button                         : PIXI.extras.AnimatedSprite;
    private _hammer                         : Hammer;     
    
    private _spaceMarineContainer           : PIXI.Container                = new PIXI.Container;
    private _spaceMarine                    : PIXI.extras.AnimatedSprite;
    private _spaceMarineFace                : PIXI.extras.AnimatedSprite;
    
    private _emotionState                   : number                        = 0;
    private _emotions                       : number[]                      = [
        1, 7, 16, 23
    ];

    private _screenButton                   : PIXI.Container;

    private _jumpHeight                     : number; // Tween background to this value
    private _maxJumpHeight                  : number; // bg height - screen height
    private _minJumpHeight                  : number                    = 65; // used if score is 0 or less than 100 (to hide bg image and hammer )
    private _jumpDuration                   : number                    = 4.5; // seconds
    private _tlJump                                                     = new TimelineMax();
    private _tlDropDelay                    : string                    = '-=0.8';
    
    
    private _score                          : number                    = 0; // save score before jump
    private _maxScoreJump                   : number                    = 900; // maximum score on background image

    private _isJumping                      : boolean                   = false;

    private _touches                        : number                    = 0; // finger on screen count 
    private _disabledTouch                  : boolean                   = false;

    private _releaseInterval;

    
    constructor() {
        super({
            time: 5,
            results: [
                '0-470',
                '471-815',
                '816-9999'
            ],
            assets: [
                { name: 'bgTop', url: 'sprite/ciel_top.png' },
                { name: 'bgBottom', url: 'sprite/ciel_bottom.png' },
                { name: 'marteau', url: 'sprite/marteau.png' },
                { name: 'push', url: 'sprite/push/push.json' },
                { name: 'cosmo', url: 'sprite/cosmonaute/cosmo.json' },
                { name: 'face', url: 'sprite/face/face.json' },

                { name: 'compte_rebours', url: 'audio/compte_rebours.mp3' },
                { name: 'friction', url: 'audio/friction.mp3' },
                { name: 'clic_marteau', url: 'audio/clic_marteau.mp3' },
                { name: 'hammertime', url: 'audio/hammertime.mp3' },
                { name: 'fin', url: 'audio/fin.mp3' },
                { name: 'vol', url: 'audio/vol.mp3' },
            ]
            
        });

        // Make Cosmocostaud getters accessible 
        Cosmocostaud.instance = this;
    }

    /*
     * @core override
     * _onPreloadComplete - Called when the preload has been completed
     * 
     */
    protected _onPreloadComplete() {
        super._onPreloadComplete();
        this._hammer = new Hammer(); // Init element Hammer
    };
    
    /*
     * @core override
     * _prepare - Prepare the game components and then starts the countdown
     * 
     */    
    protected _prepare() {
        
        // Assets
        this._bgTop = Assets.sprites['bgTop'];
        this._bgBottom = Assets.sprites['bgBottom'];
        this._button = Assets.sprites['push'];
        this._button.loop = false;
        this._spaceMarine = Assets.sprites['cosmo'];
        this._spaceMarineFace = Assets.sprites['face'];

        // Add to scene
        this._bgContainer.addChild(this._bgTop);
        this._bgContainer.addChild(this._bgBottom);
        this._bgContainer.pivot.y = this._bgContainer.height - this._screenHeight;
        
        this._spaceMarineContainer.addChild(this._spaceMarine);
        this._spaceMarineContainer.addChild(this._spaceMarineFace);
        this._spaceMarineFace.scale = new PIXI.Point(0.4, 0.4);
        this._spaceMarineFace.animationSpeed = 0.3;
        this._spaceMarineFace.onFrameChange = this._onFrameChange.bind(this);
        this._spaceMarineFace.x = this._spaceMarineContainer.width/2 - this._spaceMarineFace.width/2 + 5;
        this._spaceMarineFace.y = 50;

        this._screenButton = this._createButton(); // Create button full screen size and bind events
        this.stage.addChild(this._bgContainer);
        this.stage.addChild(this._button);
        this.stage.addChild(this._spaceMarineContainer);
        this.stage.addChild(this._hammer.el); // Add hammer element on stage
        this.stage.addChild(this._screenButton);
                
        // Trigger components positioning
        // Note: This will initialise core game components and start the countdown
        super._prepare(); 

        this._gameScore.el.style.visibility = 'hidden'; // Hide score game component before jump
    };

    /*
     * _start - Starts the game timer
     * 
     */
    protected _start() {
        super._start();
        

        Assets.sounds['running_out'].stop(); // stop time running down sound to replace with compte_rebours 
        setTimeout(() => { Assets.sounds['compte_rebours'].play(); }, 800); // small delay because sound is slower than game duration
        
        // Make hammer go lower over time
        this._releaseInterval = setInterval(() => {
            if(this._hammer.angle < 0) this._hammer.release();
        }, 100);

        // Touchevents
        this._screenButton.on(Cosmocostaud.TOUCHSTART, this._mousedown, this);
        this._screenButton.on(Cosmocostaud.TOUCHEND, this._mouseup, this);
        // Deactivate right click context menu 
        document.querySelector('.game_wrapper').addEventListener('contextmenu', (e) => {
            e.preventDefault();
            return false;
        });
    }

    /*
     * @core override
     * _onTimerComplete - on game timer complete handler 
     * @param {event} e - Event
     * 
     */
    protected _onTimerComplete(e) {
        clearInterval(this._releaseInterval);
        this._gameScore.el.style.visibility = 'visible'; // Show score on jump
        TweenMax.from(this._gameScore.el, 0.3, { autoAlpha: 0, ease: Expo.easeOut });
        TweenMax.to(this._gameTimer.el, 0.5, { alpha: 0 }); // hide game timer
        this._handleJump(e); // call game handler instead of end screen
    };

    protected _end() {
        super._end();
    }

    // Score animation during jump
    private _animateScore() {
        var score = { value: 0 };
        TweenMax.to(score, this._jumpDuration, { value: this._score, roundProps:"value", ease: Power4.easeOut,onUpdate: function() {
            this._setScore(score.value); 
        }.bind(this) });
    }

    /*
     * _handleClick - On click to raise hammer and wreck everything, add score and set jump height
     * 
     */
    private _handleClick(e) {
        // Add score
        var difficulty = 22;
        var percent = this._gameTimer.timeLeft / this._gameTimer.time; // reduce score when time lowers
        var addScore = difficulty * (1 - percent); // score difficulty
        this._score += addScore; // save score
        // Raise hammer   
        this._hammer.handle(false);
        // change character face
        this._changeEmotion();
    }

    /*
     * _handleJump - Called by _onTimerComplete
     * 
     */
    private _handleJump(e) {
        // remove event listeners
        this._screenButton.removeListener(Cosmocostaud.CLICK, this._handleClick, this);
        this._screenButton.removeListener(Cosmocostaud.TOUCHSTART, this._mousedown, this);
        this._screenButton.removeListener(Cosmocostaud.TOUCHEND, this._mouseup, this);

        // Change jump duration (default 5 seconds) and end timeline delay
        if(this._score < 200) { 
            this._jumpDuration = 1; 
            this._tlDropDelay = '-=0';
        }
        else if(this._score > 200 && this._score < 400) {
            this._jumpDuration = 2;
            this._tlDropDelay = '-=0';
        }

        // hammertime!
        this._hammer.strike(e);
    }
    
    /**
     * Different face states handler
     */
    private _changeEmotion() {
        if (this._hammer.angle >= -10) {
            var state = 0;
        } else if (this._hammer.angle < -10 && this._hammer.angle > -20) {
            var state = 1;
        } else if (this._hammer.angle < -20 && this._hammer.angle > -30) {
            var state = 2;
        } else {
            var state = 3;
        }

        if (state > this._emotionState) {
            this._emotionState = state;
            this._spaceMarineFace.play();
        }
    };

    /* 
    * Make face smile animation from angry to happy
    */
    private _reverseEmotion() {
        this._spaceMarineFace.play();
        this._spaceMarineFace.animationSpeed = -0.3; // reverse face animation
        this._spaceMarineFace.loop = false;
    }

    /*
    * Listen to face change and stop animation
    */
    private _onFrameChange(frameindex: number) {
        if (this._spaceMarineFace.currentFrame === this._emotions[this._emotionState] - 1) {
            this._spaceMarineFace.stop();
        }
    };

    /*
     * _goToEndScreen - Called when jump is finished, go to end screen
     * 
     */
    @autobind
    private _goToEndScreen(e) {
        super._onTimerComplete(e);
    }

    // Call Gamescore set to send score info
    private _setScore(score) {
        this._gameScore.set(score);
    };

    // Create fullscreen button 
    private _createButton() : PIXI.Container {
        var button = new PIXI.Container();
        button.addChild(this._drawRect(this._screenWidth, this._screenHeight, 0xFFFFFF, 1));  
        button.alpha = 0; 
        button.x = 0;      
        button.y = 0;
        button.interactive = true; // set to true for events
        button.buttonMode = true;
        button.on(Cosmocostaud.CLICK, this._handleClick, this);
        button.on(Cosmocostaud.RIGHTCLICK, this._handleClick, this);
        
        return button;  
    }

    // Draw rect method
    private _drawRect(w: number = this._screenWidth, h: number = this._screenHeight, color: number = 0xFFFFFF, alpha: number = 1) {
        let rect = new PIXI.Graphics;
        rect.beginFill(color, alpha);
        rect.drawRect(0, 0, w, h);
        rect.endFill();
        return rect;
    };

    // Prevent multitouch
    // Check if a finger is down on screen
    private _mousedown = function(e) {  
        if(this._disabled) return false; // prevent ultra fast clicks
        
        if(this._touches < 0) this._touches = 0; // bug fix -1 
        if(this._touches == 0) {
            this._handleClick(e);
            this._disabled = true; // disable click
            
            var timeout = setTimeout(() => { // enable click after delay
                this._disabled = false;
            }, 70);
        }
        this._touches++; 
    };

    // Remove finger from screen
    private _mouseup = function(e) { 
        this._touches--;
    };
    
    private _positionElements() {
        // Don't resize if game is jumping
        if(!this._isJumping) {
            // Background
            this._bgContainer.pivot.y = this._bgContainer.height - this._screenHeight;
            this._bgBottom.y = 0;
            this._bgTop.y = -this._bgBottom.height ; // position top background after bottom image
            
            this._button.y = this._screenHeight - this._button.height;
            this._spaceMarineContainer.y = this._screenHeight - this._spaceMarine.height/2 - this._button.height - 5;
            this._hammer.el.y = this._screenHeight - this._button.height - 18;
        }
    };

    /*
    * Handle end of jump assets
    */
    private _propulsionCompleted(e) {
        // Stop sounds
        Assets.sounds['fin'].play(); 
        Assets.sounds['vol'].stop();
        Assets.sounds['friction'].stop();
    }
    
    /*
     * @core override
     * _resize - Resize handler
     * @param {event} e - Event
     * 
     */
    protected _resize(e?: Event) {
        super._resize(e);
        
        if (this._gameMode === GameMode.PLAYING || typeof e === 'undefined') {
            this._positionElements();
            
            this._button.x = this._screenWidth/2 - this._button.width/2; 
            this._hammer.el.x = this._screenWidth/2 - this._hammer.el.width + 35; // Center hammer on button
            this._bgTop.x = this._screenWidth/2 - this._bgTop.width/2; // center bg image
            this._bgBottom.x = this._screenWidth/2 - this._bgBottom.width/2; // center bg image
            this._spaceMarineContainer.x = this._screenWidth/2 - this._spaceMarine.width/2; // Cosmonaute
            
            this._maxJumpHeight = this._bgContainer.height - this._screenHeight; // ex: 3000 - 320 px
        }
    };

    /*
     * handlePropulsion - Position background and make it slide down
     * 
     */
    public handlePropulsion(e) {
        // Background image bottom offset
        var bgOffset = (this._score > 150 && this._score < 600) ? 50 : 25; 
        // Save score value for jump parameter
        var jump = this._score; // save score value
        if (this._score <= 110) jump = this._minJumpHeight; // Minimum jump height value on low score 
        if (this._score > 150 && this._score < 800) jump = this._score + -bgOffset; // Jump height value if medium score 

        // Background scroll value 
        if (this._score >= this._maxScoreJump) this._jumpHeight = this._maxJumpHeight; // Max scroll to value
        else this._jumpHeight = jump / this._maxScoreJump * this._maxJumpHeight; // Scroll to value

        this._animatePropulsion(e);
    };

    /* Handle jump animations */
    private _animatePropulsion(e) {
        this._animateScore(); // Score
        Assets.sounds['friction'].play(); // Air sound

        // Background animation
        this._tlJump.to(this._bgContainer, this._jumpDuration, { y: this._jumpHeight, ease: Power4.easeOut });
        // Animate Cosmonaut drops to bottom at end of jump
        this._tlJump.to(this._spaceMarineContainer, 0.8, { y: this._screenHeight * 1.5 + this._spaceMarine.height, ease: Expo.easeIn,
            onStart: (e) => { this._propulsionCompleted(e); }, 
            onComplete: (e) => { // End game
                TweenMax.delayedCall(0.8, () => { this._goToEndScreen(e); });
            } 
        }, this._tlDropDelay); // start to drop faster
    }

    // Place space marine at different positions according to score
    public positionSpaceMarine() {
        this._isJumping = true; // Block resize on animated elements
        
        Assets.sounds['vol'].play();
        
        // Make _spacemarine go higher if score is too good else center
        if (this._score >= this._maxScoreJump)  {
            TweenMax.to(this._spaceMarineContainer, 0.5, { y: 115, ease: Expo.easeOut }); // 110 is top of image to bottom of the bell
        } else if (this._score <= 200) { // low altitude
            TweenMax.to(this._spaceMarineContainer, 1, { y: this._screenHeight / 2, ease: Expo.easeOut });
        } else {
            TweenMax.to(this._spaceMarineContainer, 0.5, { y: this._screenHeight / 2 - this._spaceMarine.height / 2, ease: Expo.easeOut }); // Center astronaut
        }

        // Start animations
        this._spaceMarine.play();
        this._reverseEmotion();
    }

    // Public accessors 
    public get buttonEl() : PIXI.Sprite { return this._button; }
    public get screenHeight() : number { return this._screenHeight; }
    public get screenWidth() : number { return this._screenWidth; }
}